import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter } from "react-router-dom";
import "./index.css";
import AppContainer from "./AppContainer";
import { SidebarProvider } from "./context/SidebarContext";
import { I18nextProvider } from "react-i18next";
import { LanguageProvider } from './i18n';
import i18next from './i18n/i18n';
import { initGlobalErrorHandling } from './utils/globalErrorHandler';

initGlobalErrorHandling();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <LanguageProvider>
        <SidebarProvider>
          <BrowserRouter future={{ v7_relativeSplatPath: true }}>
            <AppContainer />
          </BrowserRouter>
        </SidebarProvider>
      </LanguageProvider>
    </I18nextProvider>

  </React.StrictMode>
);